"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusOption = exports.textSelectFieldItemDisabledStyles = exports.textSelectFieldItemHoveredStyles = exports.textSelectFieldStyles = exports.fetchStatesAndCities = exports.toCapitalizedCase = exports.getFormattedDate = exports.classes = exports.optionCardStyles = exports.anchorStyles = exports.buttonStylesGhost = exports.buttonStylesPrimary = exports.selectFieldStyles = exports.textFieldStyles = exports.textStyles = exports.boxStyles = exports.refundProgessSummary = exports.pointsSummaryItem = exports.pointsSummaries = exports.pointsSummaryTitle = exports.pointsSummary = exports.title = exports.spinnerStyles = exports.page = exports.SelectFieldIcon = exports.CloseIconSvg = exports.SuccessIconSvg = exports.WaitingIconSvg = exports.ErrorIconSvg = exports.OptionIconSvg = exports.gray = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _glamor = require("glamor");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _hyperwalletValidCountries = require("./hyperwallet-valid-countries");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gray = exports.gray = "#FFFFFF80";

var OptionIconSvg = exports.OptionIconSvg = function OptionIconSvg() {
  return _react2.default.createElement(
    "svg",
    { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M12.9421 7.94183C13.1862 7.69776 13.1862 7.30203 12.9421 7.05795C12.698 6.81387 12.3023 6.81387 12.0582 7.05795L7.05819 12.058C6.81412 12.302 6.81412 12.6978 7.05819 12.9418C7.30227 13.1859 7.698 13.1859 7.94208 12.9418L12.9421 7.94183Z",
      fill: "#A9D34F"
    }),
    _react2.default.createElement("path", {
      d: "M12.9168 12.0832C12.9168 12.5435 12.5437 12.9166 12.0835 12.9166C11.6232 12.9166 11.2501 12.5435 11.2501 12.0832C11.2501 11.623 11.6232 11.2499 12.0835 11.2499C12.5437 11.2499 12.9168 11.623 12.9168 12.0832Z",
      fill: "#A9D34F"
    }),
    _react2.default.createElement("path", {
      d: "M7.9168 8.74989C8.37704 8.74989 8.75014 8.3768 8.75014 7.91656C8.75014 7.45632 8.37704 7.08323 7.9168 7.08323C7.45657 7.08323 7.08347 7.45632 7.08347 7.91656C7.08347 8.3768 7.45657 8.74989 7.9168 8.74989Z",
      fill: "#A9D34F"
    }),
    _react2.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.326 2.1085C10.5937 1.37627 9.40654 1.37627 8.67431 2.1085L7.42431 3.3585C7.3071 3.47571 7.14813 3.54156 6.98237 3.54156H5.4168C4.38127 3.54156 3.5418 4.38102 3.5418 5.41656V6.98213C3.5418 7.14789 3.47595 7.30686 3.35874 7.42407L2.10875 8.67407C1.37651 9.4063 1.37651 10.5935 2.10874 11.3257L3.35874 12.5757C3.47596 12.6929 3.5418 12.8519 3.5418 13.0177V14.5832C3.5418 15.6188 4.38127 16.4582 5.4168 16.4582H6.98237C7.14813 16.4582 7.3071 16.5241 7.42431 16.6413L8.67431 17.8913C9.40654 18.6235 10.5937 18.6235 11.326 17.8913L12.576 16.6413C12.6932 16.5241 12.8521 16.4582 13.0179 16.4582H14.5835C15.619 16.4582 16.4585 15.6188 16.4585 14.5832V13.0177C16.4585 12.8519 16.5243 12.6929 16.6415 12.5757L17.8915 11.3257C18.6238 10.5935 18.6238 9.4063 17.8915 8.67407L16.6415 7.42407C16.5243 7.30686 16.4585 7.14789 16.4585 6.98213V5.41656C16.4585 4.38102 15.619 3.54156 14.5835 3.54156H13.0179C12.8521 3.54156 12.6932 3.47571 12.576 3.3585L11.326 2.1085ZM9.5582 2.99238C9.80227 2.74831 10.198 2.74831 10.4421 2.99238L11.6921 4.24238C12.0437 4.59401 12.5206 4.79156 13.0179 4.79156H14.5835C14.9286 4.79156 15.2085 5.07138 15.2085 5.41656V6.98213C15.2085 7.47941 15.406 7.95632 15.7576 8.30795L17.0076 9.55795C17.2517 9.80203 17.2517 10.1978 17.0076 10.4418L15.7576 11.6918C15.406 12.0435 15.2085 12.5204 15.2085 13.0177V14.5832C15.2085 14.9284 14.9286 15.2082 14.5835 15.2082H13.0179C12.5206 15.2082 12.0437 15.4058 11.6921 15.7574L10.4421 17.0074C10.198 17.2515 9.80227 17.2515 9.55819 17.0074L8.30819 15.7574C7.95656 15.4058 7.47965 15.2082 6.98237 15.2082H5.4168C5.07162 15.2082 4.7918 14.9284 4.7918 14.5832V13.0177C4.7918 12.5204 4.59426 12.0435 4.24263 11.6918L2.99263 10.4418C2.74855 10.1978 2.74855 9.80203 2.99263 9.55795L4.24263 8.30795C4.59426 7.95632 4.7918 7.47941 4.7918 6.98213V5.41656C4.7918 5.07138 5.07162 4.79156 5.4168 4.79156H6.98237C7.47965 4.79156 7.95656 4.59401 8.30819 4.24238L9.5582 2.99238Z",
      fill: "#A9D34F"
    })
  );
};

var ErrorIconSvg = exports.ErrorIconSvg = function ErrorIconSvg() {
  return _react2.default.createElement(
    "svg",
    { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M8.99955 5.87484C9.34472 5.87484 9.62455 6.15466 9.62455 6.49984V9.83317C9.62455 10.1784 9.34472 10.4582 8.99955 10.4582C8.65437 10.4582 8.37455 10.1784 8.37455 9.83317V6.49984C8.37455 6.15466 8.65437 5.87484 8.99955 5.87484Z",
      fill: "#FF6173"
    }),
    _react2.default.createElement("path", {
      d: "M8.99955 13.5832C9.45978 13.5832 9.83288 13.2101 9.83288 12.7498C9.83288 12.2896 9.45978 11.9165 8.99955 11.9165C8.53931 11.9165 8.16621 12.2896 8.16621 12.7498C8.16621 13.2101 8.53931 13.5832 8.99955 13.5832Z",
      fill: "#FF6173"
    }),
    _react2.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.39631 16.2915C0.959063 16.2915 0.0562168 14.7409 0.765647 13.491L7.36888 1.85672C8.08742 0.590731 9.91167 0.590729 10.6302 1.85672L17.2334 13.491C17.9429 14.7409 17.04 16.2915 15.6028 16.2915H2.39631ZM1.85275 14.108C1.61628 14.5247 1.91723 15.0415 2.39631 15.0415H15.6028C16.0819 15.0415 16.3828 14.5247 16.1463 14.108L9.5431 2.47372C9.30359 2.05173 8.6955 2.05173 8.45599 2.47372L1.85275 14.108Z",
      fill: "#FF6173"
    })
  );
};

var WaitingIconSvg = exports.WaitingIconSvg = function WaitingIconSvg() {
  return _react2.default.createElement(
    "svg",
    { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M10.625 5.83333C10.625 5.48815 10.3452 5.20833 10 5.20833C9.65482 5.20833 9.375 5.48815 9.375 5.83333V10.2589L12.4747 13.3586C12.7188 13.6027 13.1145 13.6027 13.3586 13.3586C13.6026 13.1145 13.6026 12.7188 13.3586 12.4747L10.625 9.74116V5.83333Z",
      fill: "#FFC229"
    }),
    _react2.default.createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.51269 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10C18.125 5.51269 14.4873 1.875 10 1.875ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125C13.797 3.125 16.875 6.20304 16.875 10C16.875 13.797 13.797 16.875 10 16.875C6.20304 16.875 3.125 13.797 3.125 10Z",
      fill: "#FFC229"
    })
  );
};

var SuccessIconSvg = exports.SuccessIconSvg = function SuccessIconSvg() {
  return _react2.default.createElement(
    "svg",
    { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M10.625 5.83333C10.625 5.48815 10.3452 5.20833 10 5.20833C9.65482 5.20833 9.375 5.48815 9.375 5.83333V10.2589L12.4747 13.3586C12.7188 13.6027 13.1145 13.6027 13.3586 13.3586C13.6026 13.1145 13.6026 12.7188 13.3586 12.4747L10.625 9.74116V5.83333Z",
      fill: "#FFC229"
    }),
    _react2.default.createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.51269 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10C18.125 5.51269 14.4873 1.875 10 1.875ZM3.125 10C3.125 6.20304 6.20304 3.125 10 3.125C13.797 3.125 16.875 6.20304 16.875 10C16.875 13.797 13.797 16.875 10 16.875C6.20304 16.875 3.125 13.797 3.125 10Z",
      fill: "#FFC229"
    })
  );
};

var CloseIconSvg = exports.CloseIconSvg = function CloseIconSvg() {
  return _react2.default.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M7 7L17 17M17 7L7 17",
      stroke: "white",
      strokeOpacity: "0.5",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
};

var SelectFieldIcon = exports.SelectFieldIcon = function SelectFieldIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M8 10L12 14L16 10",
      stroke: "white",
      strokeOpacity: "0.5",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  );
};

var page = exports.page = (0, _glamor.css)({
  maxWidth: (0, _css.unitRem)(52),
  margin: "auto",
  fontFamily: "Roboto",
  color: gray,
  cursor: "default"
}, (0, _polyfluid.polyfluid)({
  paddingTop: {
    smallMedium: 5.625,
    large: [5.625, 7.5]
  },
  paddingBottom: {
    smallMedium: 5.625,
    large: [5.625, 7.5]
  },
  paddingLeft: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  },
  paddingRight: {
    smallMedium: 3.375,
    large: [3.375, 4.5]
  }
}));

var spinnerStyles = exports.spinnerStyles = (0, _glamor.css)({
  width: "100%",
  height: "400px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& span": {
    width: "40px",
    height: "40px",
    border: "2px solid transparent",
    borderLeftColor: "gray"
  }
});

var title = exports.title = (0, _glamor.css)({
  fontFamily: "Roboto Condensed",
  fontSize: "18px",
  fontWeight: "700",
  lineHeight: "20px",
  letterSpacing: "1px",
  textAlign: "left",
  textTransform: "uppercase",
  marginBottom: "24px"
});

var pointsSummary = exports.pointsSummary = (0, _glamor.css)({
  height: "144px",
  padding: "20px 32px",
  gap: "16px",
  borderRadius: "8px",
  background: "#1A1A1A",
  color: "#FFFFFF80"
});

var pointsSummaryTitle = exports.pointsSummaryTitle = (0, _glamor.css)({
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: "900",
  lineHeight: "14px",
  letterSpacing: "1px",
  textTransform: "uppercase",
  marginBottom: "16px"
});

var pointsSummaries = exports.pointsSummaries = (0, _glamor.css)({
  display: "inline-flex",
  flexDirection: "column",
  gap: "8px"
});

var pointsSummaryItem = exports.pointsSummaryItem = (0, _glamor.css)({
  display: "inline-flex",
  gap: "8px",
  "& span:nth-child(2)": {
    color: "white"
  }
});

var refundProgessSummary = exports.refundProgessSummary = (0, _glamor.css)({
  padding: "20px 32px",
  gap: "16px",
  borderRadius: "8px",
  background: "#1A1A1A",
  color: "#FFFFFF80"
});

var boxStyles = function boxStyles(_ref) {
  var padding = _ref.padding,
      margin = _ref.margin,
      display = _ref.display,
      rest = (0, _objectWithoutProperties3.default)(_ref, ["padding", "margin", "display"]);

  return (0, _glamor.css)((0, _extends3.default)({
    padding: padding,
    margin: margin,
    display: display
  }, rest));
};

exports.boxStyles = boxStyles;
var textStyles = function textStyles(_ref2) {
  var color = _ref2.color,
      style = _ref2.style,
      size = _ref2.size,
      height = _ref2.height,
      weight = _ref2.weight,
      transform = _ref2.transform,
      spacing = _ref2.spacing,
      rest = (0, _objectWithoutProperties3.default)(_ref2, ["color", "style", "size", "height", "weight", "transform", "spacing"]);

  return (0, _glamor.css)((0, _extends3.default)({
    color: color,
    fontStyle: style,
    fontSize: size,
    lineHeight: height,
    fontWeight: weight,
    textTransform: transform,
    letterSpacing: spacing
  }, rest));
};

exports.textStyles = textStyles;
var textFieldStyles = exports.textFieldStyles = (0, _glamor.css)({
  "& > label": {
    /* Styles for field label */
    "& > div:nth-child(1)": {
      "& > span": {
        fontSize: "14px",
        lineHeight: "14px"
      }
    },
    /* Styles for field input */
    "& > div:nth-child(2)": {
      borderRadius: "4px",
      "& > input": {
        borderRadius: "4px",
        fontSize: "14px",
        height: "32px",

        "&[type=date]": {
          textTransform: "uppercase",
          "::-webkit-calendar-picker-indicator": {
            filter: "invert(1)"
          }
        },

        "&:disabled": {
          color: "#FFFFFF40"
        }
      }
    },
    /* Styles for error at field's bottom */
    "& > span:nth-child(3)": {
      marginTop: "4px",
      fontSize: "14px",
      lineHeight: "16px"
    }
  }
});

var selectFieldStyles = exports.selectFieldStyles = (0, _glamor.css)({
  width: "100%",
  "& > label": {
    "& > span": {
      fontSize: "14px",
      lineHeight: "14px",
      color: "#808080",
      marginBottom: "0.375rem",
      letterSpacing: "0.25px"
    }
  },
  "& > div:nth-child(2)": {
    height: "32px",
    minHeight: "unset",
    "& > button": {
      fontSize: "14px",
      height: "32px",
      border: "2px solid #0f0f0f",
      color: "#FFF",
      background: "#0f0f0f",
      padding: "0 0.8999999999999999rem",
      borderRadius: "4px",
      "&:hover": {
        border: "2px solid #808080"
      },
      "&:active, &:focus": {
        border: "2px solid #2B98F0"
      }
    },
    "& > ul": {
      top: "2rem"
    }
  }
});

var buttonStylesPrimary = exports.buttonStylesPrimary = (0, _glamor.css)({
  "& button": {
    borderRadius: "4px",
    color: "black",
    padding: "6px 16px",
    backgroundColor: "#26BBFF",
    userSelect: "none",
    borderColor: "#26BBFF",
    borderWidth: "2px",
    borderStyle: "solid",

    "&:disabled": {
      backgroundColor: "transparent",
      color: "rgba(255, 255, 255, .25)",
      borderColor: "rgba(255, 255, 255, .25)",
      pointerEvents: "none",
      cursor: "not-allowed"
    }
  }
});

var buttonStylesGhost = exports.buttonStylesGhost = (0, _glamor.css)({
  "& button": {
    borderRadius: "4px",
    padding: "6px 16px",
    userSelect: "none",
    borderWidth: "2px",
    borderStyle: "solid",
    "&:disabled": {
      backgroundColor: "transparent",
      color: "rgba(255, 255, 255, .25)",
      borderColor: "rgba(255, 255, 255, .25)",
      pointerEvents: "none",
      cursor: "not-allowed"
    }
  }
});

var anchorStyles = exports.anchorStyles = (0, _glamor.css)({
  color: "#26BBFF",
  textDecoration: "underline",
  textUnderlineOffset: "2px",
  cursor: "pointer"
});

var optionCardStyles = exports.optionCardStyles = {
  root: (0, _glamor.css)({
    width: "100%",
    minWidth: "420px",
    height: "360px",
    backgroundColor: "#1A1A1A",
    borderRadius: "8px",
    padding: "32px",
    position: "relative",
    transition: "all 0.2s ease-in",
    "&:hover": {
      boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
      transform: "translate(0, -4px)"
    }
  }, (0, _css.minWidth)(_css.breakpoints.medium)({
    width: "420px"
  })),
  rootWithError: boxStyles({
    backgroundColor: "#1A1A1A80",
    "&:hover": {
      boxShadow: "none",
      transform: "none"
    },
    "& .optionCardContent": {
      color: gray + " !important",
      filter: "grayscale(100%) blur(0.5px)",
      "& span, div, p": {
        color: gray + " !important"
      }
    }
  }),
  content: boxStyles({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    justifyContent: "space-between"
  }),
  title: textStyles({
    transform: "uppercase",
    spacing: "1px",
    weight: "500",
    color: "white"
  }),
  errorRoot: boxStyles({
    position: "absolute",
    width: "100%",
    height: "100%",
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    overflow: "hidden"
  }),
  errorBackdrop: boxStyles({
    height: "100%",
    backgroundColor: "#00000070",
    borderRadius: "8px"
  }),
  errorContent: boxStyles({
    padding: "20px 24px",
    display: "flex",
    gap: "16px",
    position: "absolute",
    left: "0px",
    bottom: "0px",
    backgroundColor: "#1A1A1A",
    boxShadow: "0px -24px 24px rgba(0, 0, 0, 0.5)",
    borderRadius: "0px 0px 8px 8px"
  })
};

var classes = exports.classes = function classes() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _classnames2.default)(args.reduce(function (classes, c) {
    classes[c.toString()] = true;
    return classes;
  }, {}));
};

var getFormattedDate = exports.getFormattedDate = function getFormattedDate(date) {
  return (0, _moment2.default)(date).format("MMMM Do YYYY");
};

var toCapitalizedCase = exports.toCapitalizedCase = function toCapitalizedCase(str) {
  return str.toLowerCase().split(" ").map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(" ");
};

var fetchStatesAndCities = exports.fetchStatesAndCities = function fetchStatesAndCities(_ref3) {
  var country = _ref3.country,
      state = _ref3.state;

  if (!country && !state) {
    throw Error("You need to provide at least a country to search for states or a country and state to search for cities.");
  }

  var payload = { country: country };
  if (state) payload.state = state;

  var url = "https://countriesnow.space/api/v0.1/countries";
  if (country && state) url += "/state/cities";else if (country) url += "/states";

  var config = {
    url: url,
    method: "post",
    data: payload,
    headers: { "Content-Type": "application/json" }
  };

  var key = country && state ? "cities" : "states";

  /* Since we're using hardcoded states list for these countries, we need not send an API call to fetch these */
  if (key === "states") {
    if (country === "United States") {
      return new _promise2.default(function (resolve) {
        resolve((0, _defineProperty3.default)({}, key, _hyperwalletValidCountries.VALID_US_STATES));
      });
    }

    if (country === "Singapore") {
      return new _promise2.default(function (resolve) {
        resolve((0, _defineProperty3.default)({}, key, _hyperwalletValidCountries.VALID_SINGAPORE_STATES));
      });
    }
  }

  return (0, _axios2.default)(config).then(function (response) {
    if (key === "states") {
      var data = response.data.data[key].length ? response.data.data[key].map(function (state) {
        return { label: state.name, value: state.name };
      }) : [];
      return (0, _defineProperty3.default)({}, key, data);
    }

    if (key === "cities") {
      var _data = response.data.data.length ? response.data.data.map(function (city) {
        return { label: city, value: city };
      }) : [];
      return (0, _defineProperty3.default)({}, key, _data);
    }
  }).catch(function (error) {
    console.log("Encountered an error while fetching states/cities data:", error);
    return (0, _defineProperty3.default)({}, key, []);
  });
};

var textSelectFieldStyles = exports.textSelectFieldStyles = (0, _glamor.css)({
  position: "relative",

  "& .fieldContainer": {
    height: "52px",

    "& .inputField": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: "4px",

      "& > label": {
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: "600",
        letterSpacing: "0.25px",
        textTransform: "uppercase",
        lineHeight: "16px",
        color: "#808080"
      },

      "& .inputContainer": {
        position: "relative",
        outline: "none",

        "&:hover": {
          "& > input": {
            border: "2px solid #808080"
          }
        },
        "&:active, &:focus": {
          "& > input": {
            border: "2px solid #2B98F0"
          }
        },

        "&.hasError": {
          "& > input": {
            borderColor: "#f44236"
          }
        },

        "& > input": {
          fontSize: "14px",
          height: "32px",
          border: "2px solid #0f0f0f",
          color: "#FFF",
          background: "#0f0f0f",
          borderRadius: "4px",
          outline: "none",
          padding: "0px 14px",
          width: "100%"
        },

        "& > .optionsIcon": {
          position: "absolute",
          right: "4px",
          top: "4px",
          height: "24px",
          width: "24px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",

          "& > span": {
            height: "16px",
            width: "16px",
            borderWidth: "1px"
          }
        }
      }
    },

    "& .optionsList": {
      background: "#252525",
      borderRadius: "0px 0px 4px 4px",
      boxShadow: "0px 8px 8px rgba(0,0,0,0.25)",
      overflowY: "auto",
      position: "absolute",
      width: "100%",
      top: "52px",
      zIndex: "10",

      "& > .optionItem": {
        padding: "8px 14px",
        cursor: "default",
        outline: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",

        "&:hover": {
          background: "#2c2c2c"
        },

        "& > img": {
          width: "18px",
          height: "18px"
        }
      }
    },

    "& .fieldError": {
      marginTop: "4px",
      color: "#f44236",
      fontSize: "14px",
      lineHeight: "16px"
    }
  }
});

var textSelectFieldItemHoveredStyles = exports.textSelectFieldItemHoveredStyles = (0, _glamor.css)({
  background: "#2c2c2c"
});

var textSelectFieldItemDisabledStyles = exports.textSelectFieldItemDisabledStyles = (0, _glamor.css)({
  pointerEvents: "none",
  cursor: "not-allowed"
});

var focusOption = exports.focusOption = function focusOption(direction) {
  return function (currentIndex) {
    if (document.activeElement && document.activeElement.form) {
      var items = Array.prototype.filter.call(document.activeElement.form.querySelectorAll("div.optionItem[tabindex]"), function (element) {
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
      });

      if (direction === "next") {
        var item = items[currentIndex + 1] || items[0];
        var option = item.querySelector("option");
        item.focus();
        return {
          index: items[currentIndex + 1] ? currentIndex + 1 : 0,
          value: option.value,
          label: option.innerHTML
        };
      }

      if (direction === "prev") {
        var _item = items[currentIndex - 1] || items[items.length - 1];
        var _option = _item.querySelector("option");
        _item.focus();
        return {
          index: items[currentIndex - 1] ? currentIndex - 1 : items.length - 1,
          value: _option.value,
          label: _option.innerHTML
        };
      }
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/helpers-styles-icons.js
// module id = 273
// module chunks = 0